import { CoreButton } from '@components'
import ApproveIcon from '@images/expenses/approve.svg?react'
import RejectIcon from '@images/expenses/reject.svg?react'
import ReturnIcon from '@images/expenses/return.svg?react'
import { toastFailure } from '@utils'
import { useGetReportQuery, useProcessReportMutation } from 'mmfintech-backend-api'
import { GlobalContext, tr } from 'mmfintech-commons'
import { useContext } from 'react'
import { ApproveModal } from './ApproveModal/index'
import { RejectModal } from './RejectModal/index'
import { ReturnModal } from './ReturnModal/index'

const options = { closeOnEscape: true, closeOnClickOutside: true }

export const ReportActionButtons = ({ reportId }) => {
  const { modalShow, modalHide } = useContext(GlobalContext)

  const { data: report } = useGetReportQuery({ reportId }, { skip: !reportId })

  const [processReport] = useProcessReportMutation()

  const handleSubmit = async (payload: any) => {
    if (report) {
      try {
        await processReport({
          ...payload,
          reportId: report.id
        }).unwrap()

        modalHide()
      } catch (err) {
        toastFailure(err?.error)
      }
    }
  }

  const modalProps = {
    handleSubmit,
    reportName: report?.name,
    reportId: reportId
  }

  const handleOpenApproveModal = () => {
    modalShow({
      header: tr('FRONTEND.REPORTS.ACTIONS.APPROVE_REPORT', 'Approve Report'),
      content: <ApproveModal {...modalProps} onClose={modalHide} />,
      options
    })
  }

  const handleOpenReturnModal = () => {
    modalShow({
      header: tr('FRONTEND.REPORTS.ACTIONS.RETURN_REPORT', 'Return Report'),
      content: <ReturnModal {...modalProps} onClose={modalHide} />,
      options
    })
  }

  const handleOpenRejectModal = () => {
    modalShow({
      header: tr('FRONTEND.REPORTS.ACTIONS.REJECT_REPORT', 'Reject Report'),
      content: <RejectModal {...modalProps} onClose={modalHide} />,
      options
    })
  }

  return (
    <>
      <CoreButton
        text={tr('FRONTEND.REPORTS.ACTIONS.APPROVE', 'Approve')}
        LeftIcon={<ApproveIcon />}
        variation='primary-black'
        data-test='button-approve'
        onClick={handleOpenApproveModal}
        size='large'
      />
      <CoreButton
        text={tr('FRONTEND.REPORTS.ACTIONS.REJECT', 'Reject')}
        LeftIcon={<RejectIcon />}
        data-test='button-reject'
        onClick={handleOpenRejectModal}
        size='large'
      />
      <CoreButton
        variation='tertiary'
        text={tr('FRONTEND.REPORTS.ACTIONS.RETURN', 'Return')}
        LeftIcon={<ReturnIcon />}
        data-test='button-return'
        onClick={handleOpenReturnModal}
        size='large'
      />
    </>
  )
}
